import { MutationTree } from "vuex";
import {
  ReservationState,
  ReservationForm,
  ReservationPending
} from "../../interface";
import {
  updateReservationState,
  updateFormData,
  updateReviewData,
  updateFormResult,
  updatePendingReservation,
  resetReservationState
} from "./mutation-types";

export const mutations: MutationTree<ReservationState> = {
  [resetReservationState]: (state: ReservationState) => {
    console.log("resetReservationState");
    state.courseInfo = null;
    state.formData = null;
    state.formResults = null;
    state.reviewData = null;
    state.reservationPending = {};
    console.log(state);
  },
  [updateReservationState]: (
    state: ReservationState,
    payload: ReservationState
  ) => {
    console.log("updateReservationState:", payload);
    Object.assign(state, payload);
    state.reviewData = undefined;
    state.reservationPending = {};
  },
  [updateFormData]: (
    state: ReservationState,
    payload: {
      firstDate?: string;
    }
  ) => {
    console.log("updateFormData:", payload);
    if (state.formData) {
      if (payload.firstDate && payload.firstDate.length) {
        state.formData = {
          ...state.formData,
          firstDate: {
            ...state.formData.firstDate,
            value: payload.firstDate
          },
          diabledTimes: state.formData.fullTimeMap[payload.firstDate] || []
        };
      }
    }
  },
  [updateFormResult]: (state: ReservationState, payload: ReservationForm) => {
    console.log("updateFormResult:", payload);
    state.formResults = payload;
  },
  [updateReviewData]: (state: ReservationState, payload: string | any[]) => {
    console.log("updateReviewData:", payload);
    state.reviewData = payload;
  },
  [updatePendingReservation]: (
    state: ReservationState,
    payload: ReservationPending
  ) => {
    console.log("updatePendingReservation:", payload);
    state.reservationPending = payload;
  }
};
